module.exports = "<h4>{{$ctrl.filter.name}} <i ng-if=\"$ctrl.permission.filterConstructor\" class=\"icon-cog ng-scope\" ng-click=\"$ctrl.editFilter(); $event.stopPropagation();\" title=\"{{:: 'Свойства фильтра'  | gettext }}\"></i></h4><sc-filter-view ng-style=\"{height: $ctrl.getViewHeight()}\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" class=\"maximize\" maximize-frame=\"!$ctrl.filter.cardHeight && !$ctrl.filter.isGraph\" show-facts-info=\"false\" load-more=\"false\" click-to-use=\"true\" print-resize=\"false\"></sc-filter-view>"


//////////////////
// WEBPACK FOOTER
// ./src/view/dashboard/dashboard-node.component.html
// module id = 404
// module chunks = 0